import moment from "moment";
import { portalAnalytics as portalAnalyticsMeta } from "@/data/portal_analytics_mock";

export function formatPortalLastPointDate(isoDate) {
  if (!isoDate) {
    return null;
  }

  const parsed = moment(isoDate);
  return parsed.isValid() ? parsed.format("DD.MM.YYYY") : null;
}

const EMPTY_PURCHASE_ROWS = [
  {
    icon: "car-side",
    minimumKey: "portalHome.purchases.carMinimum",
    count: 0,
  },
  {
    icon: "truck",
    minimumKey: "portalHome.purchases.busMinimum",
    count: 0,
    countFaded: true,
  },
  {
    icon: "motorcycle",
    minimumKey: "portalHome.purchases.bikeMinimum",
    count: 0,
  },
];

export function createEmptyPortalAccount() {
  return {
    balance: 0,
    firstStopBalance: 0,
    updatedAt: null,
    purchasesYear: null,
    purchases: EMPTY_PURCHASE_ROWS.map((row) => ({ ...row })),
  };
}

export function mapPortalAnalyticsSummaryToAccount(summary) {
  const purchased = summary?.purchasedTyres;

  return {
    balance: summary?.userPoints ?? 0,
    firstStopBalance: summary?.firstStopBalance ?? 0,
    updatedAt: formatPortalLastPointDate(summary?.lastPointCreatedAt),
    purchasesYear: purchased?.year ?? null,
    purchases: [
      {
        icon: "car-side",
        minimumKey: "portalHome.purchases.carMinimum",
        count: purchased?.pc4 ?? 0,
      },
      {
        icon: "truck",
        minimumKey: "portalHome.purchases.busMinimum",
        count: purchased?.van ?? 0,
        countFaded: true,
      },
      {
        icon: "motorcycle",
        minimumKey: "portalHome.purchases.bikeMinimum",
        count: purchased?.motorcycle ?? 0,
      },
    ],
  };
}

function buildBarConfig(apiConfig, metaConfig, exportType) {
  return {
    titleKey: metaConfig.titleKey,
    thisYearColor: metaConfig.thisYearColor,
    id: metaConfig.id,
    exportType,
    byTireType: apiConfig?.byTireType ?? metaConfig.byTireType,
  };
}

function buildPieConfig(apiConfig, metaConfig, exportType) {
  return {
    titleKey: metaConfig.titleKey,
    id: metaConfig.id,
    exportType,
    byTireType: apiConfig?.byTireType ?? metaConfig.byTireType,
  };
}

export function buildPortalAnalyticsChartsConfig(apiPayload) {
  if (!apiPayload) {
    return null;
  }

  return {
    pointsVsLastYear: buildBarConfig(
      apiPayload.pointsVsLastYear,
      portalAnalyticsMeta.pointsVsLastYear,
      "pointsVsLastYear",
    ),
    tiresVsLastYear: buildBarConfig(
      apiPayload.tiresVsLastYear,
      portalAnalyticsMeta.tiresVsLastYear,
      "tiresVsLastYear",
    ),
    purchasesByInch: buildPieConfig(
      apiPayload.purchasesByInch,
      portalAnalyticsMeta.purchasesByInch,
      "purchasesByInch",
    ),
    purchasesBySupplier: buildPieConfig(
      apiPayload.purchasesBySupplier,
      portalAnalyticsMeta.purchasesBySupplier,
      "purchasesBySupplier",
    ),
  };
}
